import { education } from "../../content_option";
import { Col } from "react-bootstrap";

export const Education = () => {
    return (
        <>
            <Col lg={{ span: 4, offset: 1 }}>
                <h3 className="color_sec py-4 ">Education</h3>
            </Col>
            <Col lg="7">
                <table className="table">
                    <tbody>
                        {education.map((data, i) => {
                            return (
                                <>
                                    <tr key={i} className="header">
                                        <th scope="row">{data.location}</th>
                                        <th className="d-flex justify-content-end">
                                            <div>{data.startYear} - {data.endYear}</div>
                                        </th>
                                    </tr>
                                    <tr><td colSpan={2}>{data.title}</td></tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </Col>
        </>
    )
}